var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImageLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3811_91)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 12,
    width: 2,
    height: 2,
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 10,
    width: 2,
    height: 2,
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 2,
    height: 2,
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 6,
    width: 2,
    height: 2,
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 8,
    width: 2,
    height: 2,
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 10,
    width: 2,
    height: 2,
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 2,
    height: 2,
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    width: 2,
    height: 2,
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 2,
    height: 2,
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    width: 2,
    height: 2,
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    width: 2,
    height: 2,
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    width: 2,
    height: 2,
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    width: 2,
    height: 2,
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 4,
    width: 2,
    height: 2,
    transform: "rotate(90 20 4)",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 2,
    width: 2,
    height: 2,
    transform: "rotate(90 20 2)",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 6,
    width: 2,
    height: 2,
    transform: "rotate(90 20 6)",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 8,
    width: 2,
    height: 2,
    transform: "rotate(90 20 8)",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 10,
    width: 2,
    height: 2,
    transform: "rotate(90 20 10)",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 12,
    width: 2,
    height: 2,
    transform: "rotate(90 20 12)",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 14,
    width: 2,
    height: 2,
    transform: "rotate(90 20 14)",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 4,
    width: 2,
    height: 2,
    transform: "rotate(90 2 4)",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 2,
    height: 2,
    transform: "rotate(90 2 2)",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 6,
    width: 2,
    height: 2,
    transform: "rotate(90 2 6)",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 8,
    width: 2,
    height: 2,
    transform: "rotate(90 2 8)",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 10,
    width: 2,
    height: 2,
    transform: "rotate(90 2 10)",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 12,
    width: 2,
    height: 2,
    transform: "rotate(90 2 12)",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 14,
    width: 2,
    height: 2,
    transform: "rotate(90 2 14)",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    width: 2,
    height: 2,
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    width: 2,
    height: 2,
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 16,
    width: 2,
    height: 2,
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 16,
    width: 2,
    height: 2,
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 16,
    width: 2,
    height: 2,
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 16,
    width: 2,
    height: 2,
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 16,
    width: 2,
    height: 2,
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 16,
    width: 2,
    height: 2,
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 16,
    width: 2,
    height: 2,
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 2,
    height: 2,
    fill: "#111111"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3811_91"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageLoader);
export default __webpack_public_path__ + "static/media/image-loader.79e3273aa263bcf385e8bb53bdc16d8d.svg";
export { ForwardRef as ReactComponent };